import { render, staticRenderFns } from "./MessageButton.vue?vue&type=template&id=a308460e&scoped=true"
import script from "./MessageButton.vue?vue&type=script&lang=js"
export * from "./MessageButton.vue?vue&type=script&lang=js"
import style0 from "./MessageButton.vue?vue&type=style&index=0&id=a308460e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a308460e",
  null
  
)

export default component.exports